"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CommunicationSettings = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    horizontal: {
      flexDirection: 'row'
    },
    rightAligned: {
      justifyContent: 'flex-end'
    }
  };
});

var CommunicationSettings = function CommunicationSettings(_ref) {
  var className = _ref.className,
      onPreferredLanguageChange = _ref.onPreferredLanguageChange,
      preferredLanguage = _ref.preferredLanguage,
      props = _objectWithoutProperties(_ref, ["className", "onPreferredLanguageChange", "preferredLanguage"]);

  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.CardHeader, {
    title: t('settings.communicationTitle'),
    subheader: t('settings.communicationSubtitle')
  }), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    gutterBottom: true
  }, t('settings.preferredCommunicationLanguage')), /*#__PURE__*/_react.default.createElement(_core.RadioGroup, {
    name: "preferredCommunicationLanguage",
    className: classes.horizontal,
    onChange: onPreferredLanguageChange,
    value: preferredLanguage || ''
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    value: "en",
    control: /*#__PURE__*/_react.default.createElement(_core.Radio, null),
    label: "EN"
  }), /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    value: "de",
    control: /*#__PURE__*/_react.default.createElement(_core.Radio, null),
    label: "DE"
  }))), /*#__PURE__*/_react.default.createElement(_core.Divider, null));
};

exports.CommunicationSettings = CommunicationSettings;
CommunicationSettings.propTypes = {
  onPreferredLanguageChange: _propTypes.default.func.isRequired,
  preferredLanguage: _propTypes.default.oneOf(['en', 'de', ''])
};
var _default = CommunicationSettings;
exports.default = _default;